/** The deployed commit (set by CI as EXPO_PUBLIC_COMMIT_SHA), else "local". */
export const BUILD_COMMIT: string =
  (process.env.EXPO_PUBLIC_COMMIT_SHA ?? "").slice(0, 7) || "local";
